<template>
  <div>
    <CSidebarNavTitle v-if="hasAnyPerms([
      'menu.refunds',
      'orders.invoices.list',
      'payout.see',
      'admin.payouts.list',
    ])">{{ $gettext('Payments') }}</CSidebarNavTitle>
    
    <CSidebarNavItem
      v-if="hasAnyPerms(['menu.refunds'])"
      :name="$gettext('Refunds')"
      :to="{name: 'refund.list'}"
      icon="cip-coins-swap"
    />
    
    <CSidebarNavItem
      v-if="hasAnyPerms(['orders.invoices.list'])"
      :name="$gettext('Invoices')"
      :to="{name: 'invoice.invoice'}"
      icon="cip-doc"
    />
    
    <CSidebarNavItem
      v-if="hasAnyPerms(['payout.see']) && contract && contract.id"
      :name="$gettext('Payouts')"
      :to="{name: 'payoutList', params: { contractId: contract.id }}"
      icon="cip-wallet-02"
    />
    
    <CSidebarNavItem
      v-if="hasAnyPerms(['admin.payouts.list'])"
      :name="$gettext('Admin Payouts')"
      :to="{name: 'adminPayoutList'}"
      icon="cip-wallet-03"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Payments',
  computed: {
    ...mapGetters('events', ['contract'])
  }
}
</script>